
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import AppButton from './AppButton.vue'

@Component
export default class AppTab extends AppButton {
    @Prop({ default: false }) private selected!: boolean
    @Prop({ default: 0 }) private badge!: number
}
